module.exports = __webpack_public_path__ + "static/media/Doctor on call assistance.d4bf19eb.png";